<script setup lang="ts"></script>

<script lang="ts">
  import { defineComponent } from 'vue'

  export default defineComponent({
    name: 'TheDefaultLayout',
  })
</script>

<template>
  <main class="container mx-auto">
    <slot />
  </main>
</template>
